export default function increaseCellNumber(cell: string, inc: number) {
  let cellArr: string[] = cell
    /* eslint-disable no-useless-escape */
    ?.replace(/\'/g, "")
    ?.split(/(\d+)/)
    ?.filter(Boolean);
  return cellArr? cellArr[0] + (+cellArr[1] + inc): '';
}
